export const SET_DECISION_TIMING_ANNOUNCEMENTS = "SET_DECISION_TIMING_ANNOUNCEMENTS";
export const SET_DECISION_TIMING_RESULTS = "SET_DECISION_TIMING_RESULTS";
export const UPDATE_DECISION_TIMING = "UPDATE_DECISION_TIMING";
